module.exports = __webpack_public_path__ + "static/media/body-bg.327b0f31.png";